import script from "./resourceLibrary.vue?vue&type=script&lang=ts&setup=true"
export * from "./resourceLibrary.vue?vue&type=script&lang=ts&setup=true"

import "./resourceLibrary.vue?vue&type=style&index=0&id=e1b9bc26&scoped=true&lang=scss"
import "./resourceLibrary.vue?vue&type=style&index=1&id=e1b9bc26&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e1b9bc26"]])

export default __exports__